export function buildResumeLink(baseUrl: string, sessionId: string, email?: string): string {
  const url = new URL(baseUrl);
  // A resume link must always land on the standalone funnel, never re-enter a
  // transient presentation mode (e.g. BoatTrader's embedded modal) captured
  // from whichever tab happened to generate the link.
  url.searchParams.delete('embedded');
  // An empty sessionId can never be resumed from — set() would otherwise
  // produce a `session=` param that reads as present-but-broken downstream.
  if (sessionId) {
    url.searchParams.set('session', sessionId);
  } else {
    url.searchParams.delete('session');
  }
  if (email) {
    url.searchParams.set('email', email);
  }
  return url.toString();
}
